module.exports = __webpack_public_path__ + "img/fun04.4c755a5c.png";